import React, { useState, useEffect, useRef } from 'react';
import { Button, Container, Row, Col, Modal } from "react-bootstrap";
import { Switch, Route, useHistory, useRouteMatch, useLocation, useParams } from 'react-router-dom';
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import {
    userActions,
    resourceActions,
    templateActions,
} from '../../actions';

import { useTranslation } from 'react-i18next';

import PageTitle from "../../components/common/PageTitle";
import AuthImage from "../../components/common/AuthImage";
import { useFormik } from 'formik';

const AddResource = params => {
    const { lite, types, uploadBtn, resourceId } = params;
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    // const user = useSelector(state => state.authentication.user);
    const loading = useSelector(state => state.template.status);
    const templateId = useSelector(state => state.template.templateId);
    const group = useSelector(state => state.authentication.user.group);
    const [sendUpdate, setSendUpdate] = useState(0)
    const [resourceType, setResourceType] = useState('');
    const [resourceFileType, setResourceFileType] = useState('');
    const [selectedFile, setSelectedFile] = useState('');
    const [createComplete, setCreateComplete] = useState();
    const [frameName, setFrameName] = useState();
    const fileInputRef = useRef();
    const uploadFormRef = useRef();
    const tagsFaRef = useRef();
    const uploadBtnRef = useRef();
    const frameNameRef = useRef();
    const maskPathRef = useRef();
    const frameWidthRef = useRef();
    const frameHeightRef = useRef();
    let nameTimeout = null;

    const resourcesTypes = [
        { name: 'Image', accept: 'image/jpeg,image/png,image/svg+xml,image/gif' },
        { name: 'Shape', accept: 'image/svg+xml' },
        { name: 'Vector', accept: 'image/svg+xml' },
        { name: 'Video', accept: 'video/mp4,video/quicktime' },
        { name: 'Frame', accept: 'image/svg+xml', disable: true },
        { name: 'Grid', disable: true },
        { name: 'Line', disable: true },
    ]

    const resourceTypes = [
        { name: 'Image/Vector/Video', type: 'file', accept: 'image/jpeg,image/png,image/svg+xml,image/gif,image/svg+xml,video/mp4,video/quicktime' },
        { name: 'Frame', type: 'frame', accept: 'image/svg+xml', disable: false },
        // { name: 'Grid', type: 'grid', disable: true },
        // { name: 'Line', type: 'line', disable: true },
    ]

    const uploadTypes = ['Image', 'Shape', 'Vector', 'Video'];


    useEffect(() => {
        if (uploadBtn) {
            const btnHolder = document.getElementById(uploadBtn)
            btnHolder && btnHolder.append(uploadBtnRef.current)
            uploadBtnRef.current.style.opacity = 1;
        }
    }, [uploadBtnRef])

    useEffect(() => {
        if (createComplete === 1) {
            if (loading !== 'loading') setCreateComplete(2)
        }
    }, [loading])

    useEffect(() => {
        // checkFrameName()
        if (frameName) {
            maskPathHandler()
        }
    }, [frameName])

    const svgMask = (element) => {
        const path = _.get(element, 'path', element)
        const text = (`
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${frameWidthRef.current.value} ${frameHeightRef.current.value}">
                <mask id="mask" fill="#fff">
                    ${path}
                </mask>
                <g id="preview" fill="#5f5">
                    ${path}
                    <image href="/assets/images/noPic.jpg" height="100%" width="100%" preserveAspectRatio="xMidYMid slice" mask="url(#mask)" />
                </g>
            </svg>
        `)
        var node = document.createElement('svg')
        var parser = new DOMParser();
        var doc = parser.parseFromString(text, "image/svg+xml");
        // node.appendChild(document.createTextNode(text));
        node.innerHTML = text;
        // first an doctype
        var svgDocType = document.implementation.createDocumentType('svg', "-//W3C//DTD SVG 1.1//EN", "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd");
        // then a new SVG Document
        var svgDoc = document.implementation.createDocument('http://www.w3.org/2000/svg', 'svg', svgDocType);
        // set its documentElement to our root svg node (well a clone of it)
        svgDoc.replaceChild(node.cloneNode(true), svgDoc.documentElement);
        // serialize the document
        var svgData = (new XMLSerializer()).serializeToString(doc);
        setResourceFileType('frame')
        return svgData;
    }

    const uploadFormHandle = () => {
        uploadFormRef.current.reportValidity();
        if (!uploadFormRef.current.checkValidity()) return;
        tagsFaRef.current.value = tagsFaRef.current.value.replace(/،/g, ",")
        const formData = new FormData(uploadFormRef.current);

        setTimeout(() => {
            const files = formData.get('files');
            // const fileType = files.type.split('/')[0];
            const params = {
                // group: group,
                type: resourceFileType ? resourceFileType : selectedFile.type,
            }
            dispatch(resourceActions.upload(formData, params));
        });

    }

    const resourceTypeChangeHandler = (e) => {
        setResourceType(e.currentTarget.value)
        setSelectedFile('')
    }

    function svgToBlob(svgData) {
        var blob = new Blob([svgData], {
            type: 'image/svg+xml',
            name: 'test.svg'
        });
        return blob;
    }

    function createFileList(a) {
        a = [].slice.call(Array.isArray(a) ? a : arguments)
        for (var c, b = c = a.length, d = !0; b-- && d;) d = a[b] instanceof File
        if (!d) throw new TypeError('expected argument to FileList is File or array of File objects')
        for (b = (new ClipboardEvent('')).clipboardData || new DataTransfer; c--;) b.items.add(a[c])
        return b.files
    }

    const maskPathHandler = () => {
        const blob = svgToBlob(svgMask(_.get(maskPathRef, 'current.value', '')));
        var maskFile = new File([blob], `${frameName}.svg`, { type: 'image/svg+xml' });
        const files = createFileList(maskFile);
        fileInputRef.current.files = files;
        setTimeout(() => { fileChange({ target: { files: files } }) });
    }

    const fileChange = e => {
        const _URL = window.URL || window.webkitURL;
        const reader = new FileReader();
        const file = e.target.files[0];
        let previewSrc;


        if (file.type.includes('image') || file.type.includes('video')) {
            const img = new Image();
            var objectUrl = _URL.createObjectURL(file);
            img.onload = function () {
                _URL.revokeObjectURL(objectUrl);
                if (file.type.includes('svg')) {
                    reader.readAsText(file);
                }
            };
            previewSrc = objectUrl;
        }

        setSelectedFile({
            file: e.target.files[0],
            name: file.name,
            fileType: file.type.split('/')[0],
            imageType: file.type.split('/')[1],
            type: file.type.split('/')[1].includes('svg') ? 'Vector' : _.capitalize(file.type.split('/')[0]),
            preview: previewSrc,
        })
    }

    const svgTypeHandler = e => {
        setSelectedFile({ ...selectedFile, type: e.currentTarget.value })
    }

    const loadPreview = (event) => {
        document.getElementById('name').value = selectedFile.name;
        // if (event.target.tagName === 'VIDEO') {
        //   document.getElementById('width').value = event.target.videoWidth;
        //   document.getElementById('height').value = event.target.videoHeight;
        //   document.getElementById('duration').value = event.target.duration;
        // } else {
        //   document.getElementById('width').value = event.target.width;
        //   document.getElementById('height').value = event.target.height;
        // }
    }

    const frameNameHandler = (e) => {
        const name = e.target.value;
        if (nameTimeout) {
            clearTimeout(nameTimeout);
        }
        nameTimeout = setTimeout(() => { setFrameName(name) }, 700);
    }

    const tags = (
        <Row>
            <Col>
                <span>Tags (En):</span>
                <textarea id="tags" name="tags" />
            </Col>
            <Col>
                <span>Tags (Fa):</span>
                <textarea id="tagsFa" ref={tagsFaRef} name="tagsFa" />
            </Col>
        </Row>);

    const userGroup = (
        <Col style={lite && { display: 'none' }}>
            <span>Group:</span>
            <select id="group" name="group" value={lite && group} >
                <option value="">All Groups</option>
                <option value="vibino">Monda</option>
                <option value="bdok">bdok</option>
            </select>
        </Col>
    )

    const resourceValue = (
        <Col style={lite && { display: 'none' }}>
            <span>Value:</span>
            <select id="price" name="price"  >
                <option value="0">Free</option>
                <option value="1">Premium</option>
            </select>
        </Col>
    )

    const frameDim = (
        <>
            <Col>
                <span>Width:</span>
                <input ref={frameWidthRef} id="frameWidth" name="frameWidth" type="number" required onChange={maskPathHandler} />
            </Col>
            <Col>
                <span>Height:</span>
                <input ref={frameHeightRef} id="frameHeight" name="frameHeight" type="number" required onChange={maskPathHandler} />
            </Col>
        </>
    )

    const imageType = (
        <>
            {_.get(selectedFile, 'fileType', '') === 'image' && !_.get(selectedFile, 'imageType', '').includes('svg') &&
                <Col style={lite && { display: 'none' }}>
                    <span>Type:</span>
                    <select id="imageType" name="imageType" onChange={(e) => setResourceFileType(e.target.value)}>
                        <option value="image">Photo</option>
                        <option value="background">Background</option>
                        <option value="vector">Sticker</option>
                    </select>
                </Col>
            }
        </>
    )

    const resourceStatus = (
        <Col style={lite && { display: 'none' }}>
            <span>Status:</span>
            <select id="invisible" name="invisible" value={lite && true}>
                <option value={false}>Published</option>
                <option value={true}>Unpublished</option>
            </select>
        </Col>
    )

    const maskPath = (
        <Row>
            <Col>
                <span>Mask Path:</span><span style={{ fontStyle: 'italic', marginTop: '-10px', fontSize: '92%' }}>(Please insert single svg basic shape element like ‘circle’, ‘path’, ‘polygon’ and ‘rect’)</span>
                <textarea required ref={maskPathRef} onChange={maskPathHandler} style={{ minHeight: '4rem' }} />
            </Col>
        </Row>
    )

    const maintainRatio = (
        <>
            {_.get(selectedFile, 'imageType', '').includes('svg') &&
                <Col>
                    <span>Maintain ratio:</span>
                    <select id="vectorType" name="vectorType" onChange={svgTypeHandler} >
                        <option value="Vector">Yes</option>
                        <option value="Shape">No</option>
                    </select>
                </Col>
            }
        </>
    )

    const resourceName = (
        <Col >
            <span>Name:</span>
            {resourceType === 'frame' && <input required onChange={frameNameHandler} id="frameName" name="frameName" />}
            <input id="name" name="name" hidden={resourceType === 'frame'} disabled />
        </Col>
    )

    const vectorEditable = (
        <>
            {_.get(selectedFile, 'imageType', '').includes('svg') &&
                <Col>
                    <span>Editable:</span>
                    <select id="editable" name="editable"  >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </Col>
            }
        </>
    )

    return (
        <>
            <form id="uploadForm" ref={uploadFormRef} className={sendUpdate !== 0 && loading === 'loading' && 'blur'} >{/* onSubmit={uploadFormHandle} > */}
                <Row>
                    <Col>
                        <Row>
                            <Col lg="3">
                                <span>Resource Type:</span>
                                <select id="resourceType" name="resourceType" onChange={resourceTypeChangeHandler} >
                                    <option value="" hidden>---</option>
                                    {resourceTypes.map(option =>
                                        <option value={option.type} key={option.id} disabled={option.disable}>{`${option.name}`}</option>
                                    )}
                                </select>
                            </Col>
                            <input
                                ref={fileInputRef}
                                type="file"
                                name="files"
                                accept="image/jpeg,image/png,image/svg+xml,video/mp4,video/quicktime,image/gif"
                                onChange={fileChange}
                                hidden
                            />
                            {resourceType === 'file' &&
                                <Col>
                                    <Button
                                        style={{ position: 'absolute', bottom: 0, fontSize: '100%', minWidth: '150px' }}
                                        className="vButton colorPrimary "
                                        // content={t('uploadPictureVideo')}
                                        onClick={() => fileInputRef.current.click()}
                                    >{!selectedFile.name ? 'Add File...' : 'Change File...'}</Button>
                                </Col>
                            }
                        </Row>
                        {!resourceType &&
                            (<Row>
                                <Col>
                                    <h5>Please choose resource type.</h5>
                                </Col>
                            </Row>)
                        }
                        {(resourceType === 'frame' || (resourceType === 'file' && selectedFile.name)) &&
                            (<Row>
                                {_.get(selectedFile, 'fileType') === 'video' ?
                                    <Col lg="4" className="resourcePreview"><video onLoadedData={loadPreview} src={selectedFile.preview} className="editTemplatePreview" controls /></Col>
                                    :
                                    <Col lg="4" className="resourcePreview"><AuthImage style={resourceType === 'frame' ? { boxShadow: '0px 0px 12px #ABABAB' } : {}} onLoad={loadPreview} src={selectedFile.preview} className="editTemplatePreview" /></Col>
                                }
                                <Col>
                                    <Row>
                                        {resourceName}
                                        {resourceType !== 'frame' && imageType}
                                        {userGroup}
                                        {resourceValue}
                                        {resourceStatus}
                                    </Row>
                                    <Row>
                                        {resourceType === 'frame' && frameDim}
                                        {resourceType !== 'frame' && vectorEditable}
                                        {resourceType !== 'frame' && maintainRatio}
                                    </Row>
                                    {resourceType === 'frame' && maskPath}
                                    {!lite && tags}
                                </Col>
                            </Row>
                            )
                        }
                    </Col>
                </Row>

            </form>
            <Button ref={uploadBtnRef} style={{ opacity: '0' }} type="submit" variant="success" onClick={uploadFormHandle} disabled={!_.has(selectedFile, 'name')}><i className="material-icons"></i> Upload</Button>
            {createComplete === 2 && (
                <div className="vModal">
                    <div className="vModalContent">
                        <div className="vModalHeader">Create complete successfully</div>
                        <div className="vModalBody">New template created successfully, Please choose action to continue.</div>
                        <div className="vModalFooter">
                            <Button theme="success" onClick={() => history.push(`/templates-list`)}><i className="material-icons"></i> Start Design</Button>
                            <Button className="" theme="primary" onClick={() => history.push(`/template/${templateId}/edit`)}><i className="material-icons"></i> Upload Resources</Button>
                            <Button className="" theme="primary" onClick={() => history.go(0)}><i className="material-icons"></i> Close & New</Button>
                            <Button className="" theme="danger" onClick={() => history.push(`/templates-list`)}><i className="material-icons"></i> Close</Button>
                        </div>
                    </div>
                </div>
            )}
        </>

    );
}

export default AddResource;
